import React, { FC } from 'react';
import Navigation from 'evcharging/containers/layout/Navigation';
import Page from 'evcharging/components/Page';
import { createGetServerSideProps, StaticPageProps } from 'evcharging/app';
import Footer from 'evcharging/containers/layout/Footer';
import RebatesHeader from 'evcharging/containers/ev-rebates/RebatesHeader';
import FindProgram from 'evcharging/containers/ev-rebates/FindProgram';
import EnterPhone from 'evcharging/containers/ev-rebates/EnterPhone';
import CuttingEdge from 'evcharging/containers/ev-rebates/CuttingEdge';
import RequestConsultation from 'evcharging/containers/layout/RequestConsultation';
import { getRebates } from 'evcharging/services/cmsClient';
import { FindProgramAccordionItemProps } from 'evcharging/containers/ev-rebates/FindProgramAccordionItem';
import { EV_REBATES_LINK } from 'evcharging/app/seo/pages';
import FaqSection from 'evcharging/containers/layout/FaqSection';
import StayUpdated from 'evcharging/containers/layout/StayUpdated';
import EndToEnd from 'evcharging/containers/layout/EndToEnd';
import { GetServerSidePropsContext } from 'next/types';
import { I18nPage } from 'i18n/types/pages.enum';

interface EvRebatesProps extends StaticPageProps {
  rebates: FindProgramAccordionItemProps[];
}

const EvRebates: FC<EvRebatesProps> = ({ rebates, page }) => (
  <Page
    locales={page.locales}
    title={page.meta_title}
    description={page.meta_description}
  >
    <Navigation />
    <RebatesHeader />
    <FindProgram rebates={rebates} />
    <EnterPhone />
    <CuttingEdge />
    <EndToEnd />
    <RequestConsultation />
    <FaqSection faqs={page.faqs} />
    <StayUpdated />
    <Footer />
  </Page>
);

export const getServerSideProps = createGetServerSideProps(
  EV_REBATES_LINK,
  async (context: GetServerSidePropsContext) => {
    const rebates = await getRebates(String(context.locale));
    return { rebates };
  },
  [I18nPage.EvChargingCommon, I18nPage.Blog, I18nPage.EvChargingRebates, I18nPage.EvChargingCharger, I18nPage.EnergyRates]
);

export default EvRebates;
